/** Production site origin (Open Graph URLs must be absolute). */
export const SITE_ORIGIN = 'https://akara.ae'

/** Default social preview image — product UI (dashboard), not favicon. Served from /public. */
export const DEFAULT_OG_IMAGE_PATH = '/og-cover.png'

export function absoluteOgImageUrl(path = DEFAULT_OG_IMAGE_PATH) {
  return `${SITE_ORIGIN}${path.startsWith('/') ? path : `/${path}`}`
}
